import {
  IPropertyAutoComplete,
  IPersonAutoComplete,
  IAddressAutoComplete,
  ILocationAutoComplete,
  LocationCriteriaAutoComplete,
  IDemandAutoComplete
} from "../models/autocomplete";
import { GenericServices } from "./generic.services";
import Uri from "../common/uri/autocomplete-uri.constants";
import { ApiResponse } from "../models/app-configuration";
export interface IAutoCompleteService {
  getListOfProject(query: string): Promise<IPropertyAutoComplete[]>;
  getListOfProperties(query: string, params?: object): Promise<IPropertyAutoComplete[]>;
  getListOfPeople(query: string): Promise<IPersonAutoComplete[]>;
  getListOfAddresses(
    query: string,
    countryName?: string
  ): Promise<IAddressAutoComplete[]>;
  getPropertyLocation(
    prarms: LocationCriteriaAutoComplete
  ): Promise<ILocationAutoComplete[]>;

  getListOfDemands(query: string, params?: object): Promise<IDemandAutoComplete[]>;
  getListOfPersons(query: string, params?: object): Promise<IDemandAutoComplete[]>;
	getMapFullAddress(payload: object): Promise<any>;
}

export class AutoCompleteService extends GenericServices implements IAutoCompleteService {

  getListOfDemands(queryString: string, params?: object): Promise<IDemandAutoComplete[]> {
	  let querySerialize = this.handleSerialize(params);
	  if (querySerialize) {
		  querySerialize = '&' + querySerialize;
      }
    return this.quickSearchAutoComplete<IDemandAutoComplete>(Uri.demand, queryString, querySerialize);
  }
	
  getListOfPersons(queryString: string, params?: object): Promise<IPersonAutoComplete[]> {
	  let querySerialize = this.handleSerialize(params);
	  if (querySerialize) {
		  querySerialize = '&' + querySerialize;
      }
    return this.quickSearchAutoComplete<IPersonAutoComplete>(Uri.person, queryString, querySerialize);
  }

  getPropertyLocation(
    prarms: LocationCriteriaAutoComplete
  ): Promise<ILocationAutoComplete[]> {
    return super
      .executeSelecting(prarms, Uri.location)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      });
  }

  getListOfProject(queryString: string): Promise<IPropertyAutoComplete[]> {
      return this.quickSearchAutoComplete<IPropertyAutoComplete>(Uri.project, queryString);
  }

  getListOfProperties(queryString: string, params?: object): Promise<IPropertyAutoComplete[]> {
	  let querySerialize = this.handleSerialize(params);
	  if (querySerialize) {
		  querySerialize = '&' + querySerialize;
	  }
    return this.quickSearchAutoComplete<IPropertyAutoComplete>(Uri.property, queryString, querySerialize);
  }

  getListOfPeople(queryString: string): Promise<IPersonAutoComplete[]> {
    return this.quickSearchAutoComplete<IPersonAutoComplete>(Uri.person, queryString);
  }

  getListOfAddresses(
    queryString: string,
    countryName?: string
  ): Promise<IAddressAutoComplete[]> {
    let url = Uri.address + "?keyword=" + queryString;
    return super
      .executeSelecting(undefined, url, false)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      });
  }

  private quickSearchAutoComplete<TAutoComplete>(rootUrl: string, text: string, extendQuery:string = ""): Promise<TAutoComplete[]> {
    var url = `${rootUrl.replace("/:query", "")}?text=${encodeURIComponent(text)}${extendQuery}`; 
    return super
      .executeSelecting(undefined, url, false)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.resolve(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }
  
  private handleSerialize (params: object) {
    if (!params) return "";
    return Object.keys(params).reduce((a, k) => {
	    a.push(`${k}=${params[k]}`);
	    return a;
    }, []).join('&');
  }
	/**
   *
   */
  constructor() {
    super();
  }
  
  public getMapFullAddress(payload: object): Promise<any>{
    return super.executeSelectingPost(payload, Uri.mapFullAddress);
  }
}
